/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DisputeReason = {
    INCORRECT_SCORE: 'INCORRECT_SCORE',
    CHEATING: 'CHEATING',
    NO_SHOW: 'NO_SHOW',
    TECHNICAL_ISSUE: 'TECHNICAL_ISSUE',
    OTHER: 'OTHER'
} as const;
export type DisputeReason = typeof DisputeReason[keyof typeof DisputeReason];


export function instanceOfDisputeReason(value: any): boolean {
    for (const key in DisputeReason) {
        if (Object.prototype.hasOwnProperty.call(DisputeReason, key)) {
            if (DisputeReason[key as keyof typeof DisputeReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DisputeReasonFromJSON(json: any): DisputeReason {
    return DisputeReasonFromJSONTyped(json, false);
}

export function DisputeReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisputeReason {
    return json as DisputeReason;
}

export function DisputeReasonToJSON(value?: DisputeReason | null): any {
    return value as any;
}

export function DisputeReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): DisputeReason {
    return value as DisputeReason;
}

